import hotToast from 'react-hot-toast';

import { cn } from '@components/primitives/utilities';

export * from './Toast';
export * from './Toaster';

export const toast = Object.assign(hotToast, {
  warning(...args: Parameters<typeof hotToast.success>) {
    hotToast(args[0], {
      ...args[1],
      className: cn(args[1]?.className, 'warning'),
    });
  },
});
